import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Alert,
  // Modal
} from "react-bootstrap";
import "./login.page.css";

import * as ZUtils from "../../../modules/zutils";
import { IZLoginModule } from "../../../modules/zcommon/contracts";

export interface OwnProps { }

export interface ConnectedState {
  zLoginModule: IZLoginModule;
}

export interface ConnectedDispatch {
  despacharLogin: (idApl?: string, nombreOpcion?: string) => void;
  usernameChanged: (username: string) => void;
  passwordChanged: (password: string) => void;
  despacharCambiarContrasena: (idApl?: string, nombreOpcion?: string) => void;
}

export const LoginPage: React.FunctionComponent<OwnProps & ConnectedState & ConnectedDispatch> = (props) => {
  const [showAlert, setShowAlert] = useState('');
  // const [showModal, setShowModal] = useState(false);
  
  const setMessage = () => {
    let msj_pattern = /<msj>(.*?)<\/msj>/;
    var msj_match = props.zLoginModule.msg.match(msj_pattern);
    if (msj_match) {
      // console.log("================AZEN-MSG================");

      // console.log(props.zLoginModule.msg.match(msj_pattern))
      setShowAlert(msj_match[1]);
    }else{
      setShowAlert('');
    }
  }

  function handleKeyPress(event: any) {
    if (event.key === 'Enter') {
      onIngresarClick();
    }
  }

  const onIngresarClick = () => {
    const idApl = ZUtils.Services.getQueryStringParameter("idApl");
    const nombreOpcion = ZUtils.Services.getQueryStringParameter("opcion");
    props.despacharLogin(idApl, nombreOpcion);
  };

  const onCambiarContrasenaClick = () => {
    const idApl = ZUtils.Services.getQueryStringParameter("idApl");
    const nombreOpcion = ZUtils.Services.getQueryStringParameter("opcion");
    props.despacharCambiarContrasena(idApl, nombreOpcion);
    // setShowModal(true);
  };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  // };

  const onUsernameChanged = (e: any) => {
    props.usernameChanged(e.target.value);
  };

  const onPasswordChanged = (e: any) => {
    props.passwordChanged(e.target.value);
  };

  useEffect(() => {
    setMessage();
  }, [props.zLoginModule]);

  return (
    <div className="fondo-login">
      <Grid className="mt-5">
        <Row className="mt-5 ml-5 mr-5">
          <Col lg={5} md={6} sm={12} className="bienvenido text-primary">
            <h1 className="shadow-sm text-primary mt-8 p-3 text-center rounded titulo-bienvenido">
              {/* Bienvenid@ */}
            </h1>
            <img
              className="logo"
              src="azenweb\dist\img\azen-future.png"
              alt=""
            />
            {/* <img
              src="azenweb\src\img\oig2r.png"
              alt="icon"
              style={{marginTop: "5%", padding: "5px", width: "auto", height: "60%", maxWidth: "80%"}}
            />   */}
          </Col>

          <Col
            lg={7}
            md={6}
            sm={12}
            className="p-5 m-auto shadow-sm rounded-lg text-center container-login"
          >
            <h3 className="shadow-sm  mt-30 p-3 text-center rounded ">
              <strong> Iniciar sesión </strong>
            </h3>

            {/* <img
              className="mt-5"
              src="https://img.icons8.com/cute-clipart/64/26e07f/password.png"
              alt="icon"
            />  */}

            <Form className="m-30">
              <FormGroup controlId="formBasicEmail">
                <h5 className="shadow-sm mt-30 p-3 text-left rounded "> <strong> Usuario: </strong> </h5>
                <FormControl
                  type="username"
                  placeholder="usuario"
                  value={props.zLoginModule.username}
                  onChange={onUsernameChanged}
                  onKeyPress={handleKeyPress}
                />
              </FormGroup>

              <FormGroup controlId="formBasicPassword">
                <h5 className="shadow-sm mt-30 p-3 text-left rounded "> 
                  <strong> Contraseña: </strong> </h5>
                <FormControl
                  type="password"
                  placeholder="°°°"
                  value={props.zLoginModule.password}
                  onChange={onPasswordChanged}
                  onKeyPress={handleKeyPress}
                />
              </FormGroup>

              <Button
                bsStyle="primary btn-block mt-5 mb-5 btn-signin"
                bsSize="large"
                type="button"
                onClick={onIngresarClick}
              >
                Ingresar
              </Button>

              {/*<Button
                bsStyle="color:green"
                type="button"
                onClick={onCambiarContrasenaClick}
              >
                ¿Ha olvidado su contraseña?
              </Button> */}
            </Form>

              {/* {props.zLoginModule.msg} */}
              {showAlert && (
                <Alert bsStyle="danger">
                  {showAlert}
                </Alert>
              )}
          </Col>
        </Row>
      </Grid>
      {/* <footer className="text-right py-3">
        AZEN   {new Date().getFullYear()} &copy;
      </footer> */}
      {/* <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar Contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <p>Z-AZEN CONTRASEÑA</p>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="secondary" onClick={handleCloseModal}>
            Cerrar
          </Button>
          <Button bsStyle="primary" onClick={handleCloseModal}>
            Guardar cambios
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/portal/pages/login/Login.page.tsx